import { breakpoints, css } from '../../../styles/theme';
import { rem } from 'polished';

export const StylesDS = css`
    padding: ${rem(15)};
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey16};

    .filter-grid__prices {
        width: 300px;
    }

    &.collapsed-grid {
        max-height: ${rem(70)};
        overflow: hidden;
    }

    &.expanded-grid {
        border: 1px solid ${({ theme }) => theme.colors.grey16};
        border-top: none;
    }

    @media (min-width: ${breakpoints.md}px) {
        padding: ${rem(30)} ${rem(40)};
    }

    .mobile-filter-close-button {
        bottom: ${rem('-55px')};
        background: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.black};
        border: 1px solid ${({ theme }) => theme.colors.grey16};
        border-top: ${rem(4)} solid ${({ theme }) => theme.colors.grey16};
        font-size: ${rem(12)};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};

        &.isOpen {
            svg {
                transform: rotate(180deg);
            }
        }

        svg {
            path {
                fill: ${({ theme }) => theme.colors.black};
            }
        }
    }

    .filter-grid__fuel,
    .filter-grid__gearbox {
        @media (min-width: ${breakpoints.md}px) {
            margin-left: ${rem(50)};
        }
    }

    .grid-button {
        border-radius: ${rem(24)};
        border-color: ${({ theme }) => theme.colors.black};
        font-size: ${({ theme }) => theme.fontSizes.h5};
        color: ${({ theme }) => theme.colors.black1};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        text-transform: unset;
        position: relative;
        padding: 0 ${rem(30)};

        .info-check {
            position: absolute;
            right: ${rem(10)};
            bottom: ${rem(15)};

            svg {
                width: ${rem(18)};
                path {
                    fill: ${({ theme }) => theme.colors.primary};
                }
            }
        }

        &.active,
        &:hover,
        &:focus-visible {
            background: ${({ theme }) => theme.colors.grey4};
            border-color: ${({ theme }) => theme.colors.primary};
        }
    }

    .fuel-title,
    .gearbox-title,
    .budget-title {
        font-size: ${({ theme }) => theme.fontSizes.h5};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
    }

    .fuel-title {
        @media (min-width: ${breakpoints.md}px) {
            margin-left: ${rem(50)};
        }
    }

    .gearbox-title {
        @media (min-width: ${breakpoints.md}px) {
            margin-left: ${rem(50)};
        }
    }

    .toggle-filters {
        background: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.black};
        border: 1px solid ${({ theme }) => theme.colors.black};
        border-radius: ${rem(3)};
        text-transform: capitalize;
        font-size: ${({ theme }) => theme.fontSizes.h5};
        padding: ${rem(8)} ${rem(12)};

        .filters-title-badge {
            background: ${({ theme }) => theme.colors.primary};
            border-radius: 50%;
            width: ${rem(20)};
            height: ${rem(20)};
        }

        .icon-wrapper {
            margin-right: ${rem(5)};
        }

        svg {
            path {
                fill: ${({ theme }) => theme.colors.black};
            }
        }
    }

    .reset-filters-button {
        margin-top: ${rem(20)};
        color: ${({ theme }) => theme.colors.black};
        text-transform: capitalize;
        text-decoration: underline;
        margin-right: auto;
        margin-left: unset;

        &:hover,
        &:focus-visible {
            color: ${({ theme }) => theme.colors.primary};
        }

        @media (min-width: ${breakpoints.md}px) {
            margin-right: unset;
            margin-left: auto;
        }
    }
`;
